import { Box, Typography, Button } from '@mui/material'
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import Bookmark from '@mui/icons-material/Bookmark';
import BookmarkBorder from '@mui/icons-material/BookmarkBorder';
import IconButton from '@mui/material/IconButton';
import DetailsArrow from '../../assets/GiftAsset/detailsArrow.svg';
import CarouselDot from '../../assets/GiftAsset/carouseldots.svg';
import Star from '../../assets/star.svg'
import { useGet, usePost } from '../../hooks/useApi';
import { Yard } from '@mui/icons-material';
import { useAddCourseFavorite } from '../../hooks/useAddCourseFavorite';
import toast from 'react-hot-toast';
import { useAddGiftFavorite } from '../../hooks/useAddGiftFavorite';

const GiftCardComponent = ({title, description, amount, index,itemId, rating, category, detailspath, amountText, imageUrl}) => {
  const [bookgiftmarked, setBookgiftmarked] = useState(false);
  const [bookcoursemarked, setBookcoursemarked] = useState(false);
  const [courseFavorites, setCourseFavorites] = useState([]);
  const [giftfavorites, setGiftFavorites] = useState([]);

 
  // const [cards, setCards] = useState(initialData);
  // const {id} = useParams()
  // const { data: validateCustomer} = useGet('/api/GiftItems/validate-Customer');
  // const customerId = validateCustomer?.data.customerId

 
  // console.log(customerId)
  // const { data: addGiftFavorite} = usePost(`/api/GiftItems/add-giftItem-to-favorite?giftId=${itemId}&customerId=${customerId}`);
  // const responseGift = addGiftFavorite?.data
  // console.log(res);
  // const { data: addCourseFavorite} = usePost(`/api/Courses/add-course-to-favorite?courseId=${itemId}&customerId=${customerId}`);
  // const responseCourse = addCourseFavorite?.data
  // console.log(addCourseFavorite);
  // const { data: getCourseFavorite} = useGet(`/api/GiftItems/favorites/${customerId}`);
  // const response = getCourseFavorite?.data
  // // console.log('gift',response);
 
  const { addToFavorite } = useAddCourseFavorite();
  const {addGiftToFavorite} = useAddGiftFavorite();

  const {pathname} = useLocation();
  useEffect(() => {
    // Check if this specific course is bookmarked
    const isBookmarked = localStorage.getItem(`bookmark-${itemId}`) === 'true';
    setBookcoursemarked(isBookmarked);
    
    // If you're storing multiple bookmarks
    const savedBookmarks = JSON.parse(localStorage.getItem('bookmarked-courses') || '[]');
    setCourseFavorites(savedBookmarks);
  }, [itemId]);
  // const handleCourseBookmark = async (id)=>{
  //   if (courseFavorites.includes(id)) {
  //     toast.error('Already in favorites!', {
  //       position: "top-right"
  //     });
  //     return;
  //   }
    
  //   // setBookcoursemarked(true);

    
  //   try {
  //     await addToFavorite(id, customerId);
  //     setCourseFavorites([...courseFavorites, id]);
  //     setBookcoursemarked(true);
  //     // Show success message or update UI
  //     toast.success('Added to favorites successfully!', {
  //       position: "top-right"
  //     });
  //   } catch (err) {
  //     // Handle error in UI
  //     toast.error('Failed to add to favorites', {
  //       position: "top-right"
  //     });
  //   }
 

    
   
  // }
  const handleCourseBookmark = async (id) => {
    if (courseFavorites.includes(id)) {
      toast.error('Already in favorites!', {
        position: "top-right"
      });
      return;
    }
    
    try {
      // Save to backend
      // await addToFavorite(id, customerId);
      
      // Update state
      setCourseFavorites([...courseFavorites, id]);
      setBookcoursemarked(true);
      
      // Save to localStorage
      localStorage.setItem(`bookmark-${id}`, 'true');
      
      // If you need to store multiple bookmarks, you could store them as an array
      const existingBookmarks = JSON.parse(localStorage.getItem('bookmarked-courses') || '[]');
      localStorage.setItem('bookmarked-courses', JSON.stringify([...existingBookmarks, id]));
      
      toast.success('Added to favorites successfully!', {
        position: "top-right"
      });
    } catch (err) {
      toast.error('Failed to add to favorites', {
        position: "top-right"
      });
    }
  }
  const handleGiftBookmark = async (id)=>{
   
    if (giftfavorites.includes(id)) {
      toast.error('Already in favorites!', {
        position: "top-right"
      });
      return;
    }
    setBookgiftmarked((prev) => !prev);
  

    // try {
    //   await addGiftToFavorite(id, customerId);
    //   setGiftFavorites([...giftfavorites, id]);
      // Show success message or update UI
    //   toast.success('added to favorites successfully!', {
    //     position: "top-right"
    //   });
    // } catch (err) {
    //   // Handle error in UI
    //   console.error(err)
    //   toast.error('Failed to add to favorites', {
    //     position: "top-right"
    //   });
    // }

    
   
  }
  const navigate = useNavigate()
  return (
    <Box sx={{width:'100%', backgroundColor:'rgba(255, 255, 255, 1)', borderRadius:'20px'}}>
<Box 
  onClick={() => navigate(`/product/${detailspath}`)}
  sx={{
    height: '180px',
    backgroundImage: `url(${imageUrl})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    borderRadius: '20px 20px 0 0',
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    cursor: 'pointer'  
  }}
>

          {pathname.includes('digital-courses') ?  <Box sx={{display:"flex", justifyContent:'end'}}>
            {bookcoursemarked?
            <IconButton sx={{backgroundColor:'#fff', px:'.3rem', py:'.3rem', borderRadius:'4px'}} onClick={()=>handleCourseBookmark(itemId)}>
              <Bookmark sx={{color:"rgba(86, 4, 246, 1)"}}/>
            </IconButton>:
            <IconButton sx={{backgroundColor:'#fff', px:'.3rem', py:'.3rem', borderRadius:'4px'}} onClick={()=>handleCourseBookmark(itemId)}>
              <BookmarkBorder sx={{color:'rgba(203, 177, 252, 1)'}}/>
            </IconButton>
            }
          </Box> : <Box sx={{display:"flex", justifyContent:'end'}}>
            {bookgiftmarked?
            <IconButton sx={{backgroundColor:'#fff', px:'.3rem', py:'.3rem', borderRadius:'4px'}} onClick={()=>handleGiftBookmark(itemId)}>
              <Bookmark sx={{color:"rgba(86, 4, 246, 1)"}}/>
            </IconButton>:
            <IconButton sx={{backgroundColor:'#fff', px:'.3rem', py:'.3rem', borderRadius:'4px'}} onClick={()=>handleGiftBookmark(itemId)}>
              <BookmarkBorder sx={{color:'rgba(203, 177, 252, 1)'}}/>
            </IconButton>
            }
          </Box>}
          
         
          <Box sx={{display:'flex', justifyContent:'center'}}>
              <img src={CarouselDot} alt="dots" />
            </Box>
        </Box>
        <Box sx={{p:2}}>
              <Box sx={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
                <Box sx={{display:'flex', gap:1}}>
                  {rating?
                  <img src={Star} alt="star" style={{width:'16px', height:'16px'}}/>:<></>
                  }
                  {rating?
                  <Typography sx={{fontSize: '.8rem', display:'flex', gap:1, color:'rgba(18, 18, 18, 0.8)'}}>
                    <span>{rating}</span> <span>Ratings</span>
                  </Typography>:
                  <></>
                  }
                </Box>
                {category?
                <Typography sx={{backgroundColor:'rgba(246, 167, 4, 1)', borderRadius:'4px', px:1, textTransform:'uppercase'}}>{category}</Typography>:<></>
                }
              </Box>
              <Typography variant='h5' sx={{my:2}}>
                  {title}  {/*Luxury Flower Bouquet*/}
              </Typography>
              <Typography sx={{color:'rgba(18, 18, 18, 0.8)'}}>
                  {description}  {/*Beautifully arranged seasonal flowers */}
              </Typography>
              <Box sx={{display:'flex', alignItems:'center', gap:2}}>
                {amount?
                <Typography variant='h4' sx={{my:2, color:'rgba(246, 167, 4, 1)'}}>
                    ₦ {amount}  
                </Typography>:<></>
                }
                {amountText?
                <Typography sx={{color:'rgba(18, 18, 18, 0.5)'}}>
                  ({amountText})
                </Typography>:<></>
                }
              </Box>
              <Button variant="contained"
              onClick={()=>navigate(`/product/${detailspath}`)}
                  sx={{width:'100%',display:'flex', alignItems:'center', gap:1, textTransform:'none', color:'rgba(255, 255, 255, 1)', boxShadow:'none', backgroundColor:'rgba(86, 4, 246, 1)', py:1, px:2, minWidth:'fit-content', borderRadius:'100px', ':hover': {
            backgroundColor:'#4f03e7', 
            fontWeight:600,
            boxShadow:'0px 3px 1px -2px rgba(86, 4, 246,0.2),0px 2px 2px 0px rgba(86, 4, 246,0.14),0px 1px 5px 0px rgba(86, 4, 246,0.12)'
          }}}><span>View Details</span><img src={DetailsArrow} alt="details arrow" /></Button>
        </Box>
        
    </Box>
  )
}

export default GiftCardComponent